// Eager slim slice of the mail component barrel.
//
// Mail is a lazy sub-app: the `/mail` route folds the FULL mail context into
// the live shell context on first mount (workspace/pages/index.js →
// lazySharedLibPage), and the header envelope folds it through
// ensureMailContext (workspace/functions/mailFold.js) before opening the
// docked overlay. So the heavy surfaces — and above all `MailOverlay`, which
// the shell mounts post-fold into its MailOverlaySlot — ride the lazy chunk.
//
// The three page-body components stay eager because they are tiny,
// self-contained render closures (no data plane yet) and the page + the
// overlay both reference them by bare key. Each is `export *`-ed from its
// SOURCE file — never through `./index.js`: mail/package.json has no
// `sideEffects: false`, so a re-export through the barrel would NOT
// tree-shake and would drag the overlay into the eager chunk.
export * from './Sidebar.js'
export * from './Main.js'
export * from './EmptyState.js'
// The §3.2a setup gate and the /settings Mail card are EAGER on purpose, and
// it is not a size decision. Both render OUTSIDE the /mail route: the card
// mounts on the account settings page, and the drawer's gate paints on the
// first click of the header envelope, which happens on any route BEFORE the
// fold completes. A lazy MailSetupPanel would leave both as unresolved
// bare keys — an empty div, not a late one.
export * from './SetupPanel.js'
export * from './SettingsCard.js'
